import _FormControl from "@material-ui/core/esm/FormControl";
import _Select from "@material-ui/core/esm/Select";
import _MenuItem from "@material-ui/core/esm/MenuItem";
import _InputLabel from "@material-ui/core/esm/InputLabel";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { Notification } from '../notification';
import classes from './grey-underlined-dropdown-input.scss';
export default function DropdownInput({
  input,
  label,
  wrapperClassName,
  dropdownClassName,
  dataInput,
  hintText,
  input: {
    onChange,
    value
  } = {},
  meta: {
    touched,
    active,
    error,
    warning
  } = {},
  defaultValue = '',
  values = [],
  disabled = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wrapper, wrapperClassName)
  }, /*#__PURE__*/React.createElement(_FormControl, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(_InputLabel, {
    shrink: true,
    className: classes.selectLabel
  }, label), /*#__PURE__*/React.createElement(_Select, {
    className: dropdownClassName,
    value: value || defaultValue,
    onChange: event => onChange(event.target.value),
    inputProps: _objectSpread({}, input, {
      dataInput: {
        dataInput
      }
    }),
    classes: {
      selectMenu: classnames(classes.selectMenu, {
        [classes.placeholder]: value === ''
      }),
      root: classes.selectRoot
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(_MenuItem, {
    value: "",
    disabled: true,
    className: classes.selectItem,
    style: {
      color: 'red'
    }
  }, hintText), values.map((v, i) => /*#__PURE__*/React.createElement(_MenuItem, {
    key: `${i}_${v.value}`,
    value: v.value,
    className: classes.selectItem
  }, v.label)))), touched && !active && /*#__PURE__*/React.createElement(Notification, {
    showNotification: true,
    error: error
  }));
}